module.exports = __webpack_public_path__ + "img/ai_vip_strategy_icon.caf6bbd5.png";